import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateAreasPagination } from '../../store/actions/area/area_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import AreasTable from './areas_table';
import SearchComponent from '../ui_components/search';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const AreaList = ({ areas }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = areas;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateAreasPagination({...areas, page: 0, filters: { ...filters, search }}))
    }

    const handleAddAreaClick = () => {
        history.push(REACT_ROUTES.AREA);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Oblasti
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddAreaClick}
                    >
                        Kreirajte novu oblast
                    </Button>
                </Grid>
            </Grid>
            <AreasTable />
        </Container>
    )
}

AreaList.propTypes = {
    areas: PropTypes.object
}

const mapStateToProps = (state) => ({
    areas: state.areas
});

export default connect(mapStateToProps)(AreaList);
